import PropTypes from 'prop-types';
import React from 'react';
import { images } from 'styled';
import {
    Background,
    Brand,
    Form,
    Title
} from './styled';
const { logo } = images;

const LoginLayout = ({
    children,
    title
}) => (
    <Background>
        <Form>
            <Brand>
                <img alt="logo" src={ logo } />
            </Brand>
            <Title>
                { title }
            </Title>
            { children }
        </Form>
    </Background>
);

LoginLayout.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string
};

export default LoginLayout;
